<script setup>

import TabContainer from "@/components/global-themed/tabs/TabContainer.vue";
import TabItem from "@/components/global-themed/tabs/TabItem.vue";
import {useStore} from "vuex";
import {computed} from "vue";

const store = useStore();

const activeTab = computed(() => store.getters['actions/contentWizardActiveTab']);

const changeTab = (type) => {
  store.dispatch('actions/setContentWizardActiveTab', type)
}

const tabs = [
  {
    key: 'standard',
    text: 'Standard',
    tooltip: 'Neutral and clear, suitable for all audiences. Provides straightforward information without emotional emphasis.',
  },
  {
    key: 'enthusiastic',
    text: 'Enthusiastic',
    tooltip: 'Lively and energetic, designed to engage and excite. Uses positive language to grab attention and motivate.',
  },
  {
    key: 'professional',
    text: 'Professional',
    tooltip: 'Formal and authoritative, conveys expertise and reliability. Ideal for professional or business contexts.',
  },
]
</script>

<template>
  <TabContainer>
    <TabItem
      v-for="{key, text, tooltip} in tabs"
      :key="key"
      v-tooltip="{
        content: `${tooltip}`,
        placement: 'bottom',
        theme: 'dark-blue-tooltip',
      }"
      :active="activeTab === key"
      class="tw-flex tw-items-center tw-justify-center tw-space-x-3"
      @click="changeTab(key)"
    >
      <span class="tw-font-bold">{{ text }}</span>

      <svg-vue
        icon="icons/question"
        class="tw-w-6 tw-h-6 tw-text-blue-mid"
      />
    </TabItem>
  </TabContainer>
</template>
